"use client";

import { useRouter } from "next/navigation";
import { useEffect } from "react";
import { Loader2 } from "lucide-react";

function page() {
  const Router = useRouter();

  useEffect(() => {
    Router.push("/auth/login");
  }, []);

  return (
    <main className="min-h-screen w-full grid place-items-center">
      <div className="flex flex-col items-center gap-4">
        <img src="/Logo.webp" alt="SIPAS" className="h-24 w-auto" />
        <Loader2 className="h-8 w-8 animate-spin text-[#71277a]" />
      </div>
    </main>
  );
}

export default page;
